









































import { Component, Vue } from 'vue-property-decorator';

@Component
export default class WelcomeTmp extends Vue {
}
